<script setup lang="ts">
  import { computed } from 'vue';
  import { InputWidthVariant } from '../InputWrapper';
  import InputWrapper from '../InputWrapper/InputWrapper.vue';
  import {
    radioboxElementClass,
    radioboxLabelClass,
    radioboxWrapperClass,
  } from './Radiobox.css.ts';
  import { disabledClass } from '@tundr/theme';

  /**
   * This component is not fully developed and has to be used as controlled component
   */
  type RadioboxProps = {
    id?: string;
    testId?: string;
    title?: string;
    value?: string | unknown;
    label?: string;
    inputLabel?: string;
    name: string;
    disabled?: boolean;
    modelValue: string | unknown;
    width?: InputWidthVariant;
  };

  const props = defineProps<RadioboxProps>();

  const emits = defineEmits<{
    'update:modelValue': [value: string | boolean];
  }>();

  const isChecked = computed(() => {
    return props.modelValue === props.value;
  });

  const onChange = (e: Event) => {
    if (props.disabled) return;
    const targetValue = (e.target as HTMLInputElement).value;
    emits('update:modelValue', targetValue);
  };

  const radioWrapperClasses = computed(() => {
    return [
      radioboxWrapperClass,
      {
        [disabledClass]: props.disabled,
      },
    ];
  });
</script>

<template>
  <InputWrapper
    :id="id"
    :input-label="inputLabel"
    :width="width || InputWidthVariant.FULL"
  >
    <div :class="radioWrapperClasses">
      <input
        :data-test-id="testId"
        :class="radioboxLabelClass"
        type="radio"
        :checked="isChecked"
        :value="value"
        @change="onChange"
        :name="name"
        :id="`${name}-${value}`"
        :disabled="disabled"
      >
      <slot name="value">
        <label
          :class="radioboxElementClass"
          v-if="value"
          :for="`${name}-${value}`"
          >{{
            label
          }}</label
        >
      </slot>
    </div>
  </InputWrapper>
</template>
